import * as yup from 'yup';

export const schemaPackageContent = yup.object({
  name: yup.string().optional(),
  packageType: yup.string().optional(),
  revenueSplit: yup.string().optional(),
  commissionPercentage: yup.string().optional(),
  category: yup.string().optional(),
  addonTypes: yup.string().optional(),
  demoType: yup.string().optional(),
  bundleProduct: yup.string().optional(),
  bundleProductQty: yup.string().optional(),
});

export type PackageContentFormData = yup.InferType<typeof schemaPackageContent>;

export const schemaDisplayOptions = yup.object({
  displayName1: yup.string().optional(),
  displayName2: yup.string().optional(),
  purchasePrice: yup.string().optional(),
  maxContracts: yup.string().optional(),
  drawdownInfo: yup.string().optional(),
  footerInfo: yup.string().optional(),
  detailMin: yup.string().optional(),
  detailMax: yup.string().optional(),
});

export type DisplayOptionsFormData = yup.InferType<typeof schemaDisplayOptions>;

export const schemaFinancialsForm = yup.object({
  cashInHand: yup.string().optional(),
  autoLiquidate: yup.string().optional(),
  profitTarget: yup.string().optional(),
  autoLiquidateMinMax: yup.string().optional(),
  proAutoLiquidateMinMax: yup.string().optional(),
  durationDay: yup.string().optional(),
  buyLimit: yup.string().optional(),
  minAccountBalance: yup.string().optional(),
  commissionRate: yup.string().optional(),
  sellLimit: yup.string().optional(),
  netOpenValueUnit: yup.string().optional(),
  maxOrder: yup.string().optional(),
  minMarginBalance: yup.string().optional(),
  lossLimit: yup.string().optional(),
  proLossLimit: yup.string().optional(),
});

export type FinancialsFormData = yup.InferType<typeof schemaFinancialsForm>;

export const schemaTradovateFinancials = yup.object({
  tradovateFinancialTemplate: yup.string().optional(),
  drawDownType: yup.string().optional(),
});

export type TradovateFinancialsFormData = yup.InferType<
  typeof schemaTradovateFinancials
>;

// DxFeed schema and types - Commented out
// export const schemaDxFeedFinancials = yup.object({
//   tradovateFinancialTemplate: yup.string().optional(),
//   drawDownType: yup.string().optional(),
// });

// export type DxFeedFinancialsFormData = yup.InferType<
//   typeof schemaDxFeedFinancials
// >;

export const schemaPayoutLogic = yup.object({
  applyFirst: yup.boolean().optional(),
  allowMonthly: yup.boolean().optional(),
  allowWeekly: yup.boolean().optional(),
});

export type PayoutLogicFormData = yup.InferType<typeof schemaPayoutLogic>;

export const schemaPayoutLogicTable = yup.object({
  id: yup.string().optional(),
  payoutLogicNumber: yup.string().optional(),
  payoutFromNth: yup.string().optional(),
  payoutToNth: yup.string().optional(),
  tradingDaysRequired: yup.string().optional(),
  dailyProfitRequired: yup.string().optional(),
  minPayout: yup.string().optional(),
  maxPayout: yup.string().optional(),
  requiredBalanceThreshold: yup.string().optional(),
  clientSplit: yup.string().optional(),
});

export type TPayoutLogicTable = yup.InferType<typeof schemaPayoutLogicTable>;

export type TExchangePackagesTable = {
  id: string;
  name?: string;
  category?: string;
  visibleOnWebsite?: boolean;
  activeMintProcessing?: boolean;
  platform?: string;
};
